'use client'
import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import styles from './page.module.css';
import {
  Estatehero,
  Footer,
  FAQ,
  ReversibleComponent,
  ReverseText,
} from '../../../components'
import {
  appstorebtn,
  googleplaybtn,
  estateheader,
  gatepass,
  residentID,
} from '../../../assets'
import {
  estatebenefitsOfCommunity,
  estateCarouselItems,
} from '../../../utils/index'

const Estate = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const intervalTime = 5000

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % estateCarouselItems.length
      )
    }, intervalTime)

    return () => clearInterval(interval)
  }, [intervalTime])

  const handleCarouselClick = (index) => {
    setCurrentIndex(index)
  }

  const currentItem = estateCarouselItems[currentIndex]
  return (
    <main className={styles.estatemain}>
      <Estatehero />
      <div className={styles.estatesecondFrame}>
        <div className={styles.estatereverse}>
          <ReversibleComponent
            leftElement={
              <ReverseText
                badge='Feature'
                heading='Gate Pass'
                reversetextsmallbadge={styles.reversetextsmallbadge}
                reversetextsmallheading={styles.reversetextsmallheading}
                reversetextsmalldescription={styles.reversetextsmalldescription}
                description='CirclePlug makes managing your property easy by giving you a simple online tool to manage everything from one place.'
              />
            }
            rightElement={
              <Image
                src={gatepass}
                alt='gate pass'
                width={596.3}
                height={582}
              />
            }
            reverseStyles={styles.reverseStyles}
            estaterow={styles.estaterow}
          />
        </div>
        <div className={styles.estatereverse}>
          <ReversibleComponent
            leftElement={
              <ReverseText
                badge='Feature'
                heading='Resident ID'
                reversetextsmallbadge={styles.reversetextsmallbadge}
                reversetextsmallheading={styles.reversetextsmallheading}
                reversetextsmalldescription={styles.reversetextsmalldescription}
                description='CirclePlug creates digital ID cards for residents with passport photos on the app for easy display and scanning by estate security, enhancing security and identification.'
              />
            }
            rightElement={
              <Image
                src={residentID}
                alt='resident ID'
                width={597}
                height={570}
              />
            }
            reverseStyles={styles.reverseStyles}
            isReversed={true}
            estaterow={styles.estaterow}
          />
        </div>
      </div>

      <div className={styles.estatethirdFrame}>
        <div className={styles.estatetrials}>
          <div
            className={`${styles.estatethirdFrameImagebox} ${styles.estateImagebox}`}
          >
            <Image
              src={estateheader}
              alt='benefits of managing community by circleplug'
              className={styles.img}
              width={'100%'}
              height={'100%'}
            />
          </div>

          <div className={styles.estatebenefitcontainer}>
            <div className={styles.estatebenefitheadingwrapper}>
              <p className={styles.estatebenefitsheading}>
                Benefits of managing your estate on circleplug
              </p>
            </div>
            <div className={styles.estateCommunitycontainer}>
              {estatebenefitsOfCommunity.map(({ id, icon, title, desc }) => (
                <div key={id} className={styles.estatebenefitofcommunity}>
                  <span className={styles.communityIconbox}>{icon}</span>
                  <p className={styles.benefitofcommunitytext}>{title}</p>
                  <p className={styles.benefitofcommunitytextbottom}>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.estatefourthFrame}>
        <div className={styles.estatecarouselwithindicator}>
          <div className={styles.carouseltop}>
            <div className={styles.carouseltopleft}>
              <ul className={styles.carouseltextList}>
                {estateCarouselItems.map((item, index) => (
                  <li
                    key={item.id}
                    className={`${styles.carouseltextItem} ${
                      index === currentIndex ? styles.acarouselctiveText : ''
                    }`}
                    onClick={() => handleCarouselClick(index)}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.carouseltopright}>
              <div className={styles.carouseltopright_image}>
                <Image
                  src={currentItem.image}
                  alt={currentItem.title}
                  className={styles.img}
                />
              </div>

              <div className={styles.carouseltopright_desc}>
                <span className={styles.descriptionTitle}>
                  {currentItem.descriptionTitle}
                </span>
                {currentItem.description}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.carouselbottom}>
          {estateCarouselItems.map((item, index) => (
            <span
              key={item.id}
              className={`${styles.indicator} ${
                index === currentIndex ? styles.activeIndicator : ''
              }`}
            ></span>
          ))}
        </div>
      </div>
      <div className={styles.fifthFrame}>
        <div className={styles.thirdFramewrapper}>
          <div className={styles.thirdFrametop}>
            <div className={styles.thirdFramebadge_title}>
              <span className={styles.thirdFramebadge}>get started</span>
              <p className={styles.thirdFrame_title}>Download our App</p>
            </div>
            <p className={styles.thirdFrame_description}>
              Start your journey to empowering your community with our one stop
              app for building, engaging, and empowering your community
            </p>
          </div>
          <div className={styles.thirdFramebottom}>
            <div className={styles.platformbuttons}>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
              >
                <Image src={appstorebtn} alt='app store button' />
              </Link>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
              >
                <Image src={googleplaybtn} alt='google play button' />
              </Link>
            </div>
          </div>
        </div>

        <div className={styles.sixthFrame}>
          <div className={styles.fourthFramewrapper}>
            <FAQ />
          </div>
        </div>
        <div className={styles.estatefooter}>
          <Footer />
        </div>
      </div>
    </main>
  )
}

export default Estate
